<template>
  <div class="container mt-1">
    <div class="row bg-warning" v-if="err">
      <div class="col">{{ err }}</div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col">{{ sort }}</div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.trim="name"
          placeholder="Pool name"
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.number="count"
          placeholder="Pool size"
        />
      </div>
      <div class="col">
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle btn-sm"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ count_condition }}
          </button>
          <ul class="dropdown-menu">
            <li class="dropdown-item" @click="setCondition('min')">Min</li>
            <li class="dropdown-item" @click="setCondition('equal')">Equal</li>
            <li class="dropdown-item" @click="setCondition('max')">Max</li>
          </ul>
        </div>
      </div>
      <div class="col">
        <button class="btn btn-sm btn-primary" @click="addPool()">Add</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import { ref, onMounted, defineEmits } from "vue";
const emit = defineEmits(["poolAdded"]);
const store = useStore();
const err = ref("");
const name = ref("");
const sort = ref(null);
const color = ref("");
const count = ref(null);
const count_condition = ref("equal");
//const poolObj = ref({});
onMounted(() => {
  fetchSortCount();
});
const fetchSortCount = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  sort.value = pools.length + 1;
};
const setCondition = (str) => {
  count_condition.value = str;
};
const addPool = async () => {
  var poolObj = {
    auction_id: store.live_auction,
    sort: sort.value,
    color: null,
    name: name.value,
    count: count.value,
    count_condition: count_condition.value,
  };
  const { data, error } = await supabase
    .from("pools")
    .insert([poolObj])
    .select();
  if (error) {
    err.value = error.message;
    setTimeout(() => {
      err.value = "";
    }, 1000);
  } else {
    emit("poolAdded");
  }
};
</script>
